import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useTranslation } from 'react-i18next';
import './hero.css';
import star from '../assets/star.png';
import Button from './button';
import Label from './peoplelabel';
import people from '../assets/people.png';
import calendar from '../assets/calendar.png';

const Hero = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useLayoutEffect(() => {
    const heroElement = sectionRef.current;
    const q = gsap.utils.selector(heroElement);

    const context = gsap.context(() => {
      const topLabel = q('.label1');
      const bottomLabel = q('.label2');
      const badge = q('.hero_badge');
      const starIcon = q('.hero_label__icon');
      const titleLines = q('.hero_title_line');
      const subtitle = q('.hero_subtitle');
      const buttons = q('.hero_actions button');

      const intro = gsap.timeline({
        defaults: {
          ease: 'power3.out'
        }
      });

      intro
        .from([topLabel, bottomLabel], {
          autoAlpha: 0,
          y: 28,
          x: (index) => (index === 0 ? 64 : -64),
          rotate: (index) => (index === 0 ? 8 : -8),
          scale: 0.9,
          duration: 0.85,
          stagger: 0.08
        })
        .from(
          badge,
          {
            autoAlpha: 0,
            y: 26,
            scale: 0.92,
            duration: 0.7
          },
          0.2
        )
        .from(
          starIcon,
          {
            autoAlpha: 0,
            rotate: -40,
            scale: 0.45,
            transformOrigin: '50% 50%',
            duration: 0.9,
            ease: 'back.out(1.8)'
          },
          0.28
        )
        .from(
          titleLines,
          {
            autoAlpha: 0,
            yPercent: 120,
            rotate: 2,
            duration: 1,
            stagger: 0.12
          },
          0.34
        )
        .from(
          subtitle,
          {
            autoAlpha: 0,
            x: 28,
            y: 18,
            rotate: -10,
            duration: 0.8,
            ease: 'back.out(1.2)'
          },
          0.88
        )
        .from(
          buttons,
          {
            autoAlpha: 0,
            y: 24,
            scale: 0.94,
            duration: 0.6,
            stagger: 0.12
          },
          1
        );

      gsap.to(heroElement, {
        backgroundPosition: '50% 56%',
        duration: 18,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true
      });

      gsap.to(topLabel, {
        y: -10,
        rotate: 2,
        duration: 2.8,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 1.2
      });

      gsap.to(bottomLabel, {
        y: 10,
        rotate: -2,
        duration: 3.2,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 1.35
      });

      gsap.to(subtitle, {
        y: -8,
        duration: 2.6,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 1.4
      });

      gsap.to(starIcon, {
        rotate: 14,
        transformOrigin: '50% 50%',
        duration: 1.8,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 1
      });
    }, heroElement);

    return () => {
      context.revert();
    };
  }, []);

  return (
    <section className="hero" id="home" ref={sectionRef}>
      <div className="hero_inside">
        <Label class="label label1" labeltitle="500+" labeltext={t('hero.top_label')} labelimg={people} />
        <div className="title">
          <div className="hero_label hero_badge">
            <img className="hero_label__icon" src={star} alt="" />
            {t('hero.badge')}
          </div>
          <h1 className="hero_title">
            <span className="hero_title_line_wrap">
              <span className="hero_title_line">{t('hero.title_top')}</span>
            </span>
            <span className="hero_title_line_wrap">
              <span className="hero_title_line">
                <span className="greenaccent">{t('hero.title_green')}</span> {t('hero.title_bottom')}
              </span>
            </span>
          </h1>
          <h2 className="hero_subtitle">{t('hero.subtitle')}</h2>
          <div className="buttons hero_actions">
            <Button btntext={t('hero.browse')} btnstyle="btnstyle1" />
            <Button btntext={t('hero.book')} btnstyle="btnstyle2" />
          </div>
        </div>
        <Label class="label label2" labeltitle="500+" labeltext={t('hero.bottom_label')} labelimg={calendar} />
      </div>
    </section>
  );
};

export default Hero;
